exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-469ea661] {\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: calc(100%);\n  overflow: hidden;\n  mix-blend-mode: multiply;\n}\n.image__thumb[data-v-469ea661] {\n  max-width: 100%;\n  max-height: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: auto;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n}\n.image__thumb--placeholder[data-v-469ea661] {\n  width: auto;\n  height: auto;\n}\n", ""]);

// exports
